import { CLEAR_ANSWERS } from '../constants/actions'

export const clearAnswersAction = () => ({
  type: CLEAR_ANSWERS,
})
